import { readGithubIntegrationConfigs } from '@backstage/integration';
import { ScmAuthApi } from '@backstage/integration-react';
import { GithubApi } from './GithubApi';
import { Octokit } from '@octokit/rest';
import { ConfigApi } from '@backstage/core-plugin-api';
import { Releases } from '.';

export class GithubClient implements GithubApi {
  private readonly configApi: ConfigApi;
  private readonly scmAuthApi: ScmAuthApi;

  constructor(options: { configApi: ConfigApi; scmAuthApi: ScmAuthApi }) {
    this.configApi = options.configApi;
    this.scmAuthApi = options.scmAuthApi;
  }

  private async getToken(hostname: string): Promise<string> {
    const { token } = await this.scmAuthApi.getCredentials({
      url: `https://${hostname}/`,
      additionalScope: {
        customScopes: {
          github: ['repo'],
        },
      },
    });
    return token;
  }

  private async getOctokit(hostname: string = 'github.com'): Promise<Octokit> {
    const token = await this.getToken(hostname);
    const configs = readGithubIntegrationConfigs(
      this.configApi.getOptionalConfigArray('integrations.github') ?? [],
    );
    const githubIntegrationConfig = configs.find(v => v.host === hostname);
    const baseUrl = githubIntegrationConfig?.apiBaseUrl;
    return new Octokit({ auth: token, baseUrl });
  }

  async listReleases(options: {
    hostname?: string;
    owner: string;
    repo: string;
    pageSize?: number;
    page?: number;
  }): Promise<Releases> {
    const { hostname, owner, repo, pageSize = 100, page = 0 } = options;

    const octokit = await this.getOctokit(hostname);
    const releases = await octokit.repos.listReleases({
      owner,
      repo,
      per_page: pageSize,
      page,
    });

    return releases.data;
  }
}
